import $ from 'jquery'
import DateFilter from '@/components/date-filter';
import store_consultation from '@/store/mods/clinique/consultations';
import store_caisse from '@/store/mods/caisse/operations';

export default {
    name: 'bon-consultation',
    components: {
        DateFilter,
    },
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_load_error: false,

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',
            is_month: false,

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            fields: [
                { key: 'ref', label: 'Référence' }, 'patient', 'date',
                { key: 'action', label: 'Action.s' }
            ],

            filter: "",
            perPage: 25,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,

            filename: '',
            selected_bon: {
                info_bon_consultation: {
                    date: "",
                    reference: "",
                    nom_patient: "",
                    sexe: "",
                    telephone: "",
                    assurance: null,
                    societe_souscripteur: null,
                    expire_date: "",
                    validite: ""
                },
                libelle: "",
                prix_clinique: "",
                montant_du: "",
                montant_restant: null,
                remise: "",
                etat_annulation: null,
                etat_paiement: "",
                qte: "",
                montant_paye: "",
                part_assureur: null,
                base_assurance: null,
                taux_couverture: null,
                date: "",
                consommables_bon: [
                    {
                        uid: "",
                        data_type: "",
                        prix_clinique: "",
                        montant_du: "",
                        montant_restant: null,
                        remise: null,
                        etat_annulation: null,
                        etat_paiement: "",
                        qte: "",
                        montant_paye: "",
                        part_assureur: null,
                        base_assurance: null,
                        taux_couverture: null,
                        libelle: ""
                    },
                ]
            },
            total_du: 0,
            total_a_payer: 0,
            total_taxe_specifique: 0,
            print_data: {},
            bons_consultation_factures: []
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.current_date_filter = data
            this.is_month = true
            this.fetchLisBonConsultations()
        },
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },

    mounted() {
        this.$store.commit("SET_BONS_CONSULTATION_FACTURES", []);
        const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
        }
        this.current_date_filter = data
        this.fetchLisBonConsultations()
    },

    methods: {
        fetchLisBonConsultations() {
            this.is_loading = true
            store_consultation.getListBonConsultations(this.current_date_filter).then((response) => {
                this.bons_consultation_factures = response.data
                this.total_pages = response.last_page
                if (this.bons_consultation_factures.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                
                this.is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.is_loading = false
            })
        },

        async fetchInfoFacturationBonMedical(info_bon) {
            this.selected_bon.date = info_bon.date_emission
            this.selected_bon.reference = info_bon.reference_bon
            this.selected_bon.nom_patient = info_bon.nom_patient
            this.selected_bon.sexe = info_bon.sexe
            this.selected_bon.age = info_bon.age
            this.selected_bon.telephone = info_bon.telephone
            this.selected_bon.assurance = info_bon.assurance
            this.selected_bon.societe_souscripteur = info_bon.societe_souscripteur
            this.selected_bon.expire_date = info_bon.duree_info.expiration_date
            this.selected_bon.validite = info_bon.duree_info.duree_in_time+' '+info_bon.duree_info.unite

            this.total_a_payer = 0
            this.total_du = 0

            const data = {
                uid: info_bon.uid
            }
            await store_caisse.getInfoFacturationBonConsultation(data).then((response) => {
                
                this.selected_bon.libelle = response.libelle
                this.selected_bon.prix_clinique = response.prix_unitaire
                this.selected_bon.montant_du = response.montant_du
                this.selected_bon.remise = response.coupon
                this.selected_bon.qte = response.qte
                this.selected_bon.montant_paye = response.montant_paye
                this.selected_bon.part_assureur = response.part_assureur
                this.selected_bon.base_assurance = response.base_assurance
                this.selected_bon.taux_couverture = response.taux_assurance
                this.selected_bon.consommables_bon = response.consommables_bon

                this.total_du = response.montant_du
                this.total_a_payer += (response.prix_unitaire > response.base_assurance)?response.prix_unitaire:response.base_assurance
                this.total_taxe_specifique += response.taxe_specifique

                response.consommables_bon.forEach(consommable => {
                    if (consommable.data_type == 'apport_social') {
                        this.total_du -= consommable.montant_du
                    } else {
                        this.total_du += consommable.montant_du
                        this.total_a_payer += consommable.prix_clinique
                    }
                    this.total_taxe_specifique += consommable.taxe_specifique
                });

                this.print_data = {
                    data_type: 'bon_consultation',   
                    prestation: 'Bon de consultation',
                    selected_bon: this.selected_bon,
                    total_taxe_specifique: this.total_taxe_specifique,
                    total_a_payer: this.total_a_payer,
                    total_du: this.total_du
                }

                setTimeout(() => {
                    this.$emit('emitPrintBon', this.print_data)
                }, 200);
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.fetchLisBonConsultations()
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.current_date_filter.page = this.currentPage
                this.fetchLisBonConsultations()
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.current_date_filter.page = this.currentPage
                this.fetchLisBonConsultations()
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.current_date_filter.page = this.currentPage
                this.fetchLisBonConsultations()
            }
        },
    }
}